import React from 'react';
import type { CustomFeature } from '@types';
import Input from '@components/Input';
import { Collapse } from '@components/Collapse';
import useInputHandlers from '@hooks/useInputHandelrs';
import useGetFeatureTitle from '@hooks/useGetFeatureTitle';
import { useCustomFeature } from '../CustomFeatureContext';

function CButtonTitle() {
  const { data, setData } = useCustomFeature<CustomFeature>();
  const getFTitle = useGetFeatureTitle();
  const titleHandler = useInputHandlers((val) =>
    setData((draft) => {
      draft.title = val;
    })
  );

  return (
    <Collapse title="标题设置">
      <Input
        maxLength={50}
        scheme="dark"
        className="h-30"
        placeholder={getFTitle(data.code)}
        value={data.title}
        {...titleHandler}
      />
    </Collapse>
  );
}

export default CButtonTitle;
